angular.module('fd.allEvents').controller('AllEventsListController', ($scope, $rootScope, EventService, EventGroupService, $q,
  FormDataStoreService, $filter, PaginationService, $timeout, ValidatorService, LoadingService, BBModel, Lightbox, $location) => {

  let i;
  const loader = LoadingService.$loader($scope).notLoaded();

  $scope.pick = {};
  $scope.start_date = moment();
  $scope.end_date = moment().endOf('year');
  $scope.filters = { hide_fully_booked_events: false };
  $scope.pagination = PaginationService.initialise({ page_size: 10, max_size: 5 });
  $scope.events = {};
  $scope.fully_booked = false;
  $scope.event_data_loaded = false;
  $scope.eventsNextYear;

  FormDataStoreService.init('AllEventsListController', $scope, [
    'selected_date',
    'event_group_id',
    'event_group_manually_set'
  ]);

  $rootScope.connection_started.then(() => {
    const companyidParam = document.URL.match(/companyId=([0-9]+)/)

    if (companyidParam) {
      var companyId = companyidParam[1];
    }

    if (!companyId) {
      // FD - automatically re-select the parent company when we return to the page so that
      // we can see all events for all child companies
      if ($scope.bb.extra_setup.merge_child_events && $scope.bb.company.$has('parent')) {
        return $scope.bb.company.$getParent().then($scope.setCompany);
      }
    }
  }).then(function () {

    if ($scope.bb.company) {
      // if there's a default event, skip this step
      if (($scope.bb.item_defaults && $scope.bb.item_defaults.event) || ($scope.bb.current_item.defaults && $scope.bb.current_item.defaults.event)) {

        $scope.skipThisStep();
        $scope.decideNextPage();
        return;

      } else if ($scope.bb.company.$has('parent') && !$scope.bb.company.$has('company_questions')) {

        return $scope.bb.company.$getParent().then((parent) => {
          $scope.company_parent = parent;
          return $scope.initialise();
        }
          , err => loader.setLoadedAndShowError(err, 'Sorry, something went wrong'));

      } else {

        return $scope.initialise();
      }
    }
  }, err => loader.setLoadedAndShowError(err, 'Sorry, something went wrong'));


  $scope.initialise = function () {

    let event_group;
    loader.notLoaded();

    if ($scope.mode !== 0) {
      delete $scope.selected_date;
    }

    // has the event group been manually set (i.e. in the step before)
    if (!$scope.event_group_manually_set && ($scope.bb.current_item.event_group == null)) {
      $scope.event_group_manually_set = ($scope.event_group_manually_set == null) && ($scope.bb.current_item.event_group != null);
    }

    // clear current item
    if ($scope.bb.current_item.event) {
      ({ event_group } = $scope.bb.current_item);
      // $scope.clearBasketItem();
      // TODO only remove the basket items added in this session
      // $scope.emptyBasket();
      if ($scope.event_group_manually_set) {
        $scope.bb.current_item.setEventGroup(event_group);
      }
    }

    const promises = [];

    // company question promise
    if ($scope.bb.company.$has('company_questions')) {
      promises.push($scope.bb.company.$getCompanyQuestions());
    } else if (($scope.company_parent != null) && $scope.company_parent.$has('company_questions')) {
      promises.push($scope.company_parent.$getCompanyQuestions());
    } else {
      promises.push($q.when([]));
      $scope.has_company_questions = false;
    }

    // event group promise
    if ($scope.bb.item_defaults && $scope.bb.item_defaults.event_group) {
      $scope.bb.current_item.setEventGroup($scope.bb.item_defaults.event_group);
    } else if (!$scope.bb.current_item.event_group && ($scope.bb.company.$has('event_groups') || $scope.bb.extra_setup.merge_child_events)) {
      // --------------------------------------------------------------------------------
      // By default, the API returns the first 100 event_groups. We don't really want
      // to paginate event_groups (athough we DO want to paginate events)
      // so I have hardcoded the EventGroupService query to return all event_groups
      // by passing in a suitably high number for the per_page param
      // ---------------------------------------------------------------------------------
      // promises.push(EventGroupService.query($scope.bb.company, {per_page: 500}));
      // FD - Replaced with function to get all event groups for all children
      if (!$scope.bb.company.child_companies && $scope.bb.company.id == 37000) {
        $scope.bb.company.$getChildren().then(function (child_companies) {
          $scope.bb.company.child_companies = child_companies;
          promises.push($scope.getChildEventGroups($scope.bb.company));
        });
      } else {
        promises.push($scope.getChildEventGroups($scope.bb.company));
      }
    } else {
      promises.push($q.when([]));
    }

    // event summary promise
    // FD - we generate the event summary from the actual events, so we don't need to make a request for summaries separately
    // if (($scope.mode === 0) || ($scope.mode === 2)) {
    //     promises.push($scope.loadEventSummary());
    // } else {
    promises.push($q.when([]));
    // }

    // event data promise
    // TODO - always load some event data?
    if (($scope.mode === 1) || ($scope.mode === 2)) {
      promises.push($scope.loadEventData());
    } else {
      promises.push($q.when([]));
    }


    return $q.all(promises).then((result) => {
      const company_questions = result[0];
      const event_groups = result[1];

      $scope.has_company_questions = (company_questions != null) && (company_questions.length > 0);
      if (company_questions) {
        buildDynamicFilters(company_questions);
      }
      $scope.event_groups = event_groups;

      // Add EventGroup to Event so we don't have to make network requests using item.getGroup() from the view
      const event_groups_collection = _.indexBy(event_groups, 'id');
      if ($scope.items) {
        for (const item of Array.from($scope.items)) {
          item.group = event_groups_collection[item.service_id];
        }
      }
    }, err => loader.setLoadedAndShowError(err, 'Sorry, something went wrong'));
  };

  $scope.getChildEventGroups = function (parentCompany) {
    if ($scope.bb.extra_setup.merge_child_events) {
      // FD - request event groups from all children
      let promises = [];
      parentCompany.child_companies.forEach(childCompany => {
        if (childCompany.$has('event_groups')) {
          promises.push(EventGroupService.query(childCompany, { per_page: 500 }).then(eventGroups => {
            // Add the company name to the event groups so we can easily use it in the template
            eventGroups.forEach(eventGroup => {
              eventGroup.companyName = childCompany.name;
            });
            return eventGroups;
          }));
        }
      });

      return $q.all(promises).then(results => {
        return _.flatten(results);
      });
    } else {
      // FD - request event groups from the selected company only
      return EventGroupService.query(parentCompany, { per_page: 500 });
    }
  };

  $scope.getChildSummaries = function (parentCompany, params) {
    if ($scope.bb.extra_setup.merge_child_events) {
      // FD - request summaries from all children
      let promises = [];
      parentCompany.child_companies.forEach(childCompany => {
        promises.push(BBModel.Event.$summary(childCompany, params));
      });

      return $q.all(promises).then(results => {
        return _.unique(_.flatten(results));
      });
    } else {
      // FD - request summaries from the selected company only
      return BBModel.Event.$summary(parentCompany, params);
    }
  };


  /***
   * @ngdoc method
   * @name loadEventChainData
   * @methodOf FD:fdAllEvents
   * @description
   * Load event chain data in according of comp parameter
   *
   * @param {array} comp The company
   */
  $scope.loadEventChainData = function (comp) {

    const deferred = $q.defer();

    if ($scope.bb.item_defaults.event_chain) {
      deferred.resolve([]);
    } else {
      loader.notLoaded();
      if (!comp) {
        comp = $scope.bb.company;
      }

      const params = {
        item: $scope.bb.current_item,
        start_date: $scope.start_date.toISODate(),
        end_date: $scope.end_date.toISODate()
      };
      if ($scope.events_options.embed) {
        params.embed = $scope.events_options.embed;
      }
      if ($scope.client) {
        params.member_level_id = $scope.client.member_level_id;
      }

      $scope.getChildEventChainData(comp, params).then(function (event_chains) {
        return deferred.resolve(event_chains);
      }, err => deferred.reject());
    }

    return deferred.promise;
  };

  $scope.getChildEventChainData = function (parentCompany, params) {
    if ($scope.bb.extra_setup.merge_child_events) {
      // FD - request event groups from all children
      let promises = [];
      parentCompany.child_companies.forEach(childCompany => {
        if (childCompany.$has('event_chains')) {
          promises.push(BBModel.EventChain.$query(childCompany, params));
        }
      });

      return $q.all(promises).then(results => {
        return _.unique(_.flatten(results));
      });
    } else {
      // FD - request event groups from the selected company only
      return BBModel.EventChain.$query(parentCompany, params);
    }
  };

  $scope.getDatesBetween = (startDate, endDate) => {
    var dateArray = new Array();
    var currentDate = startDate;
    while (currentDate <= endDate) {
      dateArray.push(new Date(currentDate));
      currentDate = moment(currentDate).add(1, 'days');
    }
    dateArray.push(new Date(endDate));
    return dateArray;
  }

  $scope.generateSummary = async function (items) {
    let item_dates;
    if (items && (items.length > 0)) {

      item_dates = [];
      for (let item of Array.from(items)) {

        // BOOKINGLAB change
        // Checks if the event is an exhibition event and grabs the multi day events if so
        // Highlights all multi days on calendar
        const chain = await item.$getEventChain()
        if ($scope.showExhibitions) {
          let d = moment(item.date);
          item_dates.push({
            date: d,
            idate: parseInt(d.format("YYYYDDDD")),
            count: 1,
            spaces: 1,
          });
        } else {
          let d = moment(item.date);
          item_dates.push({
            date: d,
            idate: parseInt(d.format("YYYYDDDD")),
            count: 1,
            spaces: 1,
          });
        }
      }

      $scope.item_dates = item_dates.sort((a, b) => a.idate - b.idate);

      // TODO clear the selected date if the event group has changed (but only when event group has been explicity set)
      // if $scope.bb.current_item? and $scope.bb.current_item.event_group?
      //   if $scope.bb.current_item.event_group.id != $scope.event_group_id
      //     $scope.showDay($scope.item_dates[0].date)
      //   $scope.event_group_id = $scope.bb.current_item.event_group.id

      // if the selected date is within range of the dates loaded, show it, else show the first day loaded
      if ($scope.mode === 0) {
        if ($scope.selected_date && ($scope.selected_date.isAfter($scope.item_dates[0].date) || $scope.selected_date.isSame($scope.item_dates[0].date)) && ($scope.selected_date.isBefore($scope.item_dates[$scope.item_dates.length - 1].date) || $scope.selected_date.isSame($scope.item_dates[$scope.item_dates.length - 1].date))) {
          $scope.showDay($scope.selected_date);
        } else {
          $scope.showDay($scope.item_dates[0].date);
        }
      }
    } $scope.$apply();
  };

  /***
   * @ngdoc method
   * @name loadEventData
   * @methodOf FD:fdAllEvents
   * @description
   * Load event data. De-select the event chain if there's one already picked - as it's hiding other events in the same group
   *
   * @param {array} comp The company parameter
   */
  $scope.loadEventData = function (comp) {
    if (!$scope.bb.company.$getChildren) {
      // add $gerChildren prototype to company
      $scope.bb.company.$getChildren = function () {
        return $q.all([]);
      }
    }
    $scope.bb.company.$getChildren().then(function (child_companies) {

      $scope.bb.company.child_companies = child_companies;

      loader.notLoaded();

      $scope.event_data_loaded = false;

      // clear the items when in summary mode
      if ($scope.mode === 0) {
        delete $scope.items;
      }

      const deferred = $q.defer();

      const current_event = $scope.bb.current_item.event;

      if (!comp) {
        comp = $scope.bb.company;
      }

      // de-select the event chain if there's one already picked - as it's hiding other events in the same group
      if ($scope.bb.current_item && ($scope.bb.current_item.event_chain_id || $scope.bb.current_item.event_chain)) {
        delete $scope.bb.current_item.event_chain;
        delete $scope.bb.current_item.event_chain_id;
      }

      let params = {
        item: $scope.bb.current_item,
        start_date: $scope.start_date.toISODate(),
        end_date: $scope.end_date.toISODate(),
        include_non_bookable: true
      };

      $scope.eventParams = params;

      let newDate = new Date();
      let NextYear = newDate.getFullYear() + 1;

      // get start date and end date of next year
      let start_date = new Date(NextYear, 0, 1).toISOString().split('T')[0];
      let end_date = new Date(NextYear, 11, 31).toISOString().split('T')[0];;

      let paramsNextYear = {
        item: $scope.bb.current_item,
        start_date,
        end_date,
        include_non_bookable: true,
        per_page: 99999 // dont look at this
      };

      if ($scope.events_options.event_data_embed) {
        params.embed = $scope.events_options.event_data_embed;
      }

      if ($scope.bb.item_defaults.event_chain) {
        params.event_chain_id = $scope.bb.item_defaults.event_chain.id;
      }

      // Change for support Ticket: SUPPWB-40
      // WB wanted more results on the event list, However pagination does not seem work
      // So this is the temporary solution
      $scope.per_page = 10;

      if ($scope.per_page) {
        params.per_page = $scope.per_page;
      }

      const chains = $scope.loadEventChainData(comp);

      $scope.events = {};

      // get events for next year
      // $scope.getChildEventData(comp, paramsNextYear).then((eventsNextYear) => {
      // $scope.eventsNextYear = eventsNextYear;
      $scope.eventsNextYear = []

      $scope.getChildEventData(comp, params).then(function (events) {
        // Flatten events array
        $scope.items = _.flatten(events);

        // Generate the summary dates to appear in the top overview calendars
        $scope.generateSummary($scope.items);

        // Add spaces_left prop - so we don't need to use ng-init="spaces_left = getSpacesLeft()" in the html template
        for (const item of Array.from($scope.items)) {
          item.spaces_left = item.getSpacesLeft();
        }

        // Add address prop from the company to the item
        $scope.getChildAddresses(comp).then(addresses =>

          (() => {
            const result = [];
            for (const item of Array.from($scope.items)) {
              addresses.forEach(address => {
                if (item.company_id == address.company_id) {
                  result.push(item.address = address);
                }
              });
            }
            return result;
          })()
        );

        // TODO make this behave like the frame timetable
        // get all data then process events
        return chains.then(() => {

          const prepPromises = [];
          // get more event details
          for (const item of Array.from($scope.items)) {

            params = { embed: $scope.events_options.embed };
            if ($scope.client) {
              params.member_level_id = $scope.client.member_level_id;
            }
            prepPromises.push(item.prepEvent(params));

            // check if the current item already has the same event selected
            if (($scope.mode === 0) && current_event && (current_event.self === item.self)) {

              item.select();
              $scope.event = item;
            }
          }

          $q.all(prepPromises).then(all => {
            // All events prepped and now have a chain - rerun the filter
            $scope.filterChanged();
            loader.setLoaded();

            // now we have loaded 10 events and set the page, we can load the rest in the "background"
            $scope.eventParams.per_page = 99999;
            $scope.getChildEventData(comp, $scope.eventParams).then((thisYearsEvents) => {
              // because we have the 10 events already, we need to filter them out or there will be dupes
              // filter out $scope.items from thisYearsEvents
              $scope.thisYearsEvents = thisYearsEvents.filter(event => {
                return !$scope.items.find(item => item.id === event.id);
              });

              // flatten the events to we can push them into our items array
              $scope.thisYearsEvents = _.flatten($scope.thisYearsEvents);
              // $scope.items.concat($scope.thisYearsEvents)
              $scope.getEventData(comp, $scope.thisYearsEvents);
              deferred.resolve();
            });

            // now that the app is loaded, we can request next years events in the background
            $scope.getChildEventData(comp, paramsNextYear).then((eventsNextYear) => {
              // flatten the eventsNextYear array and push it to the events array
              $scope.eventsNextYear = _.flatten(eventsNextYear);
              // $scope.items.concat($scope.eventsNextYear)
              $scope.getEventData(comp, $scope.eventsNextYear);
              deferred.resolve();
            });
          });

          // only build item_dates if we're in 'next 100 event' mode
          if ($scope.mode === 1) {

            let idate;
            const item_dates = {};

            if (items.length > 0) {

              for (const item of Array.from(items)) {

                // item.getDuration();
                idate = parseInt(item.date.format('YYYYDDDD'));
                item.idate = idate;

                if (!item_dates[idate]) {
                  item_dates[idate] = { date: item.date, idate, count: 0, spaces: 0 };
                }

                item_dates[idate].count += 1;
                item_dates[idate].spaces += item.num_spaces;
              }

              $scope.item_dates = [];

              for (const x in item_dates) {

                const y = item_dates[x];
                $scope.item_dates.push(y);
              }

              $scope.item_dates = $scope.item_dates.sort((a, b) => a.idate - b.idate);

            } else {

              idate = parseInt($scope.start_date.format('YYYYDDDD'));
              $scope.item_dates = [{ date: $scope.start_date, idate, count: 0, spaces: 0 }];
            }
          }

          // determine if all events are fully booked
          $scope.isFullyBooked();

          // $scope.items = $scope.items.sort((a, b) => a.idate - b.idate);

          $scope.filtered_items = $scope.items;

          // run the filters to ensure any default filters get applied
          $scope.filterChanged();

          // update the paging
          PaginationService.update($scope.pagination, $scope.filtered_items.length);

          $scope.event_data_loaded = true;

          return deferred.resolve($scope.items);
        }, err => deferred.reject());
      }, err => deferred.reject());
      // }, err => deferred.reject());

      return deferred.promise;
    });
  };

  /**
   * Retrieve the addresses of each of the child accounts
   */
  $scope.getChildAddresses = function (parentCompany) {
    if ($scope.bb.extra_setup.merge_child_events) {
      // FD - address groups from all children
      let promises = [];
      parentCompany.child_companies.forEach(childCompany => {
        if (childCompany.$has('address')) {
          promises.push(childCompany.$getAddress().then(address => {
            address.company_id = childCompany.id;
            return address;
          }));
        }
      });

      return $q.all(promises).then(results => {
        return _.flatten(results);
      });
    } else {
      // FD - request address from the selected company only
      return parentCompany.$getAddress().then(address => {
        address.company_id = parentCompany.id;
        return [address];
      })
    }
  };

  $scope.getEventData = function (parentCompany, items) {
    const prepPromises = [];
    let params;
    // get more event details
    for (const item of Array.from(items)) {

      params = { embed: $scope.events_options.embed };
      if ($scope.client) {
        params.member_level_id = $scope.client.member_level_id;
      }
      prepPromises.push(item.prepEvent(params));

      // check if the current item already has the same event selected
      if (($scope.mode === 0) && current_event && (current_event.self === item.self)) {

        item.select();
        $scope.event = item;
      }
    }

    $q.all(prepPromises).then((all) => {
      $scope.items = _.flatten([$scope.items, all]);
      $scope.items = $scope.items.sort((a, b) => a.date - b.date);
      // run the filters to ensure any default filters get applied
      $scope.filterChanged($scope.items);

      // update the paging
      PaginationService.update($scope.pagination, $scope.items.length);
    });
  }

  /**
   * Retrieve all of the events for each child
   */
  $scope.getChildEventData = function (parentCompany, params) {
    if ($scope.bb.extra_setup.merge_child_events) {
      // FD - request event data from all children
      let promises = [];
      parentCompany.child_companies.forEach(childCompany => {
        promises.push(BBModel.Event.$query(childCompany, params).then(items => {
          items.forEach(item => {
            item.company = childCompany;
          });
          return items;
        }));
      });

      return $q.all(promises).then(results => {
        let allEvents = _.flatten(results);
        return _.sortBy(allEvents, function (event) {
          return event.datetime;
        });
      });
    } else {
      // FD - request event data from the selected company only
      return BBModel.Event.$query(parentCompany, params).then(items => {
        items.forEach(item => {
          item.company = parentCompany;
        });
        return items;
      })
    }
  };


  /***
   * @ngdoc method
   * @name isFullyBooked
   * @methodOf FD:fdAllEvents
   * @description
   * Verify if the items from event list are be fully booked
   */
  $scope.isFullyBooked = function () {

    const full_events = [];

    for (const item of Array.from($scope.items)) {

      if (item.num_spaces === item.spaces_booked) {
        full_events.push(item);
      }
    }

    if (full_events.length === $scope.items.length) {
      return $scope.fully_booked = true;
    }
  };


  /***
   * @ngdoc method
   * @name showDay
   * @methodOf FD:fdAllEvents
   * @description
   * Selects a day or filters events by day selected
   *
   * @param {moment} the day to select or filter by
   */
  $scope.showDay = function (date) {

    let new_date;
    if (!moment.isMoment(date)) {
      return;
    }

    if ($scope.mode === 0) {

      // unselect the event if it's not on the day being selected
      if ($scope.event && !$scope.selected_date.isSame(date, 'day')) {
        delete $scope.event;
      }
      new_date = date;
      $scope.start_date = moment(date);
      $scope.end_date = moment(date);
      $scope.loadEventData();

    } else {

      if (!$scope.selected_date || !date.isSame($scope.selected_date, 'day')) {
        new_date = date;
      }
    }

    if (new_date) {

      $scope.selected_date = new_date;
      $scope.filters.date = new_date.toDate();

    } else {

      delete $scope.selected_date;
      delete $scope.filters.date;
    }

    return $scope.filterChanged();
  };


  $scope.$watch('pick.date', (new_val, old_val) => {

    if (new_val) {

      $scope.start_date = moment(new_val);
      $scope.end_date = moment(new_val);
      return $scope.loadEventData();
    }
  }
  );


  /***
   * @ngdoc method
   * @name selectItem
   * @methodOf FD:fdAllEvents
   * @description
   * Select an item into the current event list in according of item and route parameters
   *
   * @param {array} item The Event or BookableItem to select
   * @param {string=} route A specific route to load
   */
  $scope.selectItem = (item, route) => {

    // SUP-11 - Removed to allow the user to still select the more info button
    // if (((item.getSpacesLeft() > 0) || !$scope.bb.company.settings.has_waitlists) && !item.hasSpace()) {
    //   return false;
    // }

    loader.notLoaded();

    if ($scope.$parent.$has_page_control) {

      if ($scope.event) {
        $scope.event.unselect();
      }
      $scope.event = item;
      $scope.event.select();
      loader.setLoaded();

      return false;

    } else {

      $scope.setCompany(item.company).then(() => {
        if ($scope.bb.moving_purchase) {
          for (i of Array.from($scope.bb.basket.items)) {
            i.setEvent(item);
          }
        }

        $scope.bb.current_item.setEvent(item);
        $scope.bb.current_item.ready = false;

        $q.all($scope.bb.current_item.promises).then(() =>
          $scope.decideNextPage(route), err => loader.setLoadedAndShowError(err, 'Sorry, something went wrong'));
      });

      return true;
    }
  };


  /***
   * @ngdoc method
   * @name setReady
   * @methodOf FD:fdAllEvents
   * @description
   * Set this page section as ready - see {@link BB:bbPage Page Control}
   */
  $scope.setReady = function () {

    if (!$scope.event) {
      return false;
    }

    $scope.bb.current_item.setEvent($scope.event);

    return true;
  };


  /***
   * @ngdoc method
   * @name filterEvents
   * @methodOf FD:fdAllEvents
   * @description
   * Filter events from the event list in according of item parameter
   *
   * @param {array} item The Event or BookableItem to select
   */
  $scope.filterEvents = function (item) {
    const result = item.chain &&
      (moment($scope.filters.date).isSame(item.date, 'day') || ($scope.filters.date == null)) &&
      (($scope.filters.event_group && (item.service_id === $scope.filters.event_group.id)) || ($scope.filters.event_group == null)) &&
      ((($scope.filters.price != null) && (item.price_range.from <= $scope.filters.price)) || ($scope.filters.price == null)) &&
      (($scope.filters.hide_fully_booked_events && (item.getSpacesLeft() > 0)) || !$scope.filters.hide_fully_booked_events) &&
      $scope.filterEventsWithDynamicFilters(item);

    return result;
  };


  $scope.filterEventsWithDynamicFilters = function (item) {

    if (!$scope.has_company_questions || !$scope.dynamic_filters) {
      return true;
    }

    let result = true;

    for (const type of Array.from($scope.dynamic_filters.question_types)) {

      let filter;
      if (type === 'check') {

        for (const dynamic_filter of Array.from($scope.dynamic_filters['check'])) {

          const name = dynamic_filter.name.parameterise('_');
          filter = false;

          if (item.chain && item.chain.extra[name]) {

            for (i of Array.from(item.chain.extra[name])) {
              filter = ($scope.dynamic_filters.values[dynamic_filter.name] && (i === $scope.dynamic_filters.values[dynamic_filter.name].name)) || ($scope.dynamic_filters.values[dynamic_filter.name] == null);

              if (filter) {
                break;
              }
            }

          } else if ((item.chain.extra[name] === undefined) && (_.isEmpty($scope.dynamic_filters.values) || ($scope.dynamic_filters.values[dynamic_filter.name] == null))) {

            filter = true;
          }

          result = result && filter;
        }

      } else {

        for (const dynamic_filter of Array.from($scope.dynamic_filters[type])) {

          // FD - if we have "multi-option" filters (a filter that works on multiple questions)
          // then handle them here
          if (dynamic_filter.multiOption) {
            let multiFilter = false;
            // Loop through each of the original questions and check whether the filter matches any of them
            // E.g. multiFilter is true if the filter value matches Question1 OR Question2 OR Question3...
            dynamic_filter.originalQuestions.forEach(originalQuestion => {
              const originalName = originalQuestion.name.parameterise('_');
              multiFilter = multiFilter || ($scope.dynamic_filters.values[dynamic_filter.name] && (item.chain.extra[originalName] === $scope.dynamic_filters.values[dynamic_filter.name].name)) || ($scope.dynamic_filters.values[dynamic_filter.name] == null);
            });
            filter = multiFilter;
          } else {
            const name = dynamic_filter.name.parameterise('_');
            filter = ($scope.dynamic_filters.values[dynamic_filter.name] && (item.chain.extra[name] === $scope.dynamic_filters.values[dynamic_filter.name].name)) || ($scope.dynamic_filters.values[dynamic_filter.name] == null);
          }
          result = result && filter;
        }
      }
    }

    return result;
  };


  /***
   * @ngdoc method
   * @name filterDateChanged
   * @methodOf FD:fdAllEvents
   * @description
   * Filtering data exchanged from the list of events
   */
  $scope.filterDateChanged = function (options) {

    if (options == null) {
      options = { reset: false };
    }
    if ($scope.filters.date) {
      const date = moment($scope.filters.date);
      $scope.$broadcast('event_list_filter_date:changed', date);
      $scope.showDay(date);

      if ((options.reset === true) || ($scope.selected_date == null)) {

        return $timeout(() => delete $scope.filters.date
          , 250);
      }
    }
  };


  /***
   * @ngdoc method
   * @name resetFilters
   * @methodOf FD:fdAllEvents
   * @description
   * Reset the filters
   */
  $scope.resetFilters = function () {
    $location.search({}); // Clear URL of Params
    $scope.filters = {};
    if ($scope.has_company_questions) {
      $scope.dynamic_filters.values = {};
    }
    $scope.filterChanged();

    delete $scope.selected_date;
    $scope.generateSummary($scope.items);
    return $rootScope.$broadcast('event_list_filter_date:cleared');
  };


  // build dynamic filters using company questions
  const buildDynamicFilters = function (questions) {

    // Remove the 'hidden' filter by filtering through
    // the questions and removing it
    questions = questions.filter(x => x.name != ('hidden'));
    questions = questions.filter(x => x.name != ('Bookable'));
    questions = questions.filter(x => x.reference != ('heycentric_rev_code')); // remove hey centric codes

    // FD - Keep only the first event category
    let mergedQuestions = [];
    let merged = {};

    // FD - Keep only the questions we explicitly want to filter on
    if ($scope.bb.extra_setup.show_filter_questions) {
      questions = _.filter(questions, question => {
        return $scope.bb.extra_setup.show_filter_questions.indexOf(question.id) >= 0;
      });
    }
    // FD - Hide the questions defined in the extra setup
    if ($scope.bb.extra_setup.hide_filter_questions) {
      questions = _.filter(questions, question => {
        return $scope.bb.extra_setup.hide_filter_questions.indexOf(question.id) < 0;
      });
    }

    questions.forEach(question => {
      // FD check for multi-option categories (has a # followed by a number, e.g. Heritage Category #1, Heritage Category #2)
      if (question.multiOption && question.originalQuestions) {
        // FD - question already flagged as a multi-option question and has associated questions attached
        mergedQuestions.push(question);
      } else if (question.multiOption && !question.originalQuestions) {
        // FD - question already flagged as a multi-option question and doesn't have associated questions attached
        // (i.e. it is one of the child questions)
        // Do nothing - ignore this as it is already kept under the parent question
      } else if (question.name.indexOf(' #') >= 0) {
        const commonName = question.name.split(' #')[0];
        question.multiOption = true;
        if (merged[commonName]) {
          // Store the original question againts the filter. We then check against these when the filter is changed
          merged[commonName].originalQuestions.push(question);
          // Merge values
          question.question_items.forEach(newItem => {
            let existing = merged[commonName].question_items.filter(existingItem => {
              return newItem.name == existingItem.name;
            });
            if (existing.length === 0) {
              merged[commonName].question_items.push(newItem);
            }
          });

          // We have to filter out special characters here or matching will fail when the filter changes
          question.name = $filter('wordCharactersAndSpaces')(question.name);
        } else {
          // Keep the first instance of this multi-option question
          merged[commonName] = question;
          // Set the display name to get rid of the #1, #2 etc
          question.displayName = commonName;
          // Store some additional information on the filter that we use later during matching
          question.originalQuestions = [question];
          mergedQuestions.push(question);
        }
      } else {
        // This is a normal question, so just add it
        mergedQuestions.push(question);
      }
    });

    questions = _.each(mergedQuestions, question => question.name = $filter('wordCharactersAndSpaces')(question.name));

    $scope.dynamic_filters = _.groupBy(questions, 'question_type');
    $scope.dynamic_filters.question_types = _.uniq(_.pluck(questions, 'question_type'));
    return $scope.dynamic_filters.values = {};
  };


  // TODO build price filter by determiniug price range, if range is large enough, display price filter
  // buildPriceFilter = () ->
  //   for item in items

  /***
   * @ngdoc method
   * @name filterChanged
   * @methodOf FD:fdAllEvents
   * @description
   * Change filter of the event list
   */
  $scope.filterChanged = async function () {
    if ($scope.items) {

      $scope.filtered_items = $filter('filter')($scope.items, $scope.filterEvents);
      let eventsBeforeExhibitionFilter = $scope.filtered_items.length;

      // check if the museum exhibitions category has been selected
      $scope.showExhibitions = false;
      if ($scope.dynamic_filters) {
        let keys = Object.keys($scope.dynamic_filters.values);
        keys.forEach(key => {
          if ($scope.dynamic_filters.values[key] && $scope.dynamic_filters.values[key].name == 'Museum Exhibitions') {
            $scope.showExhibitions = true;
          }
          if ($scope.dynamic_filters.values[key] && $scope.dynamic_filters.values[key].name == 'West Berkshire Museum') {
            $scope.showExhibitions = true;
          }
        });
      }

      // remove hidden items 
      $scope.filtered_items = $scope.filterHidden($scope.filtered_items);

      $scope.items.forEach(item => {
        if (item.chain) {
          const filteredDate = moment($scope.filters.date);
          if (!$scope.filtered_items.includes(item)) {
            if (filteredDate <= item.date && filteredDate >= item.chain.end_date) {
              $scope.filtered_items.push(item);
            }
          }
        }
      });

      // If a museum exhibitions category has been selected
      // then keep only the first exhibition else removed exhibitions
      if ($scope.showExhibitions) {
        $scope.filtered_items = $scope.filterExhibitions($scope.filtered_items);
      } else {
        $scope.filtered_items = $scope.removeExhibitions($scope.filtered_items);
      }

      $scope.pagination.num_items = $scope.filtered_items.length;
      $scope.filter_active = eventsBeforeExhibitionFilter !== $scope.items.length;

      $scope.generateSummary($scope.items);

      // check if the events are multiday events
      await $scope.multiDayEventCheck($scope.filtered_items);

      return PaginationService.update($scope.pagination, $scope.filtered_items.length);
    }
  };

  $scope.filterHidden = function (items) {
    $scope.generateSummary($scope.items);
    return items.filter(function (item) {
      return item.chain && item.chain.extra && item.chain.extra.hidden == 'No'
    });
  };

  $scope.filterExhibitions = function (items) {
    const filtered = [];
    const seenExhibitionChains = [];

    items.forEach(item => {
      if (item.chain && item.chain.extra && item.chain.extra.exhibition == 'Yes') {
        if (seenExhibitionChains.indexOf(item.chain.id) > -1) {
          // Already seen this exhibition chain
        } else {
          // First time seeing this one, add it
          seenExhibitionChains.push(item.chain.id);
          filtered.push(item);
        }
      } else {
        filtered.push(item);
      }
    });

    return filtered;
  };

  $scope.removeExhibitions = function (items) {
    const filtered = [];

    items.forEach(item => {
      if (item.chain && item.chain.extra && item.chain.extra.exhibition == 'Yes') {
        // do nothing
      } else {
        filtered.push(item);
      }
    });

    return filtered;
  };

  $scope.multiDayEventCheck = function (events) {

    // loop over each event from events and group the ones together where event.group.name are the same
    const groupedEvents = _.groupBy(events, function (event) {
      if (event.chain.recurrence_type != "") {
        return `${event.chain.name}`;
      } else {
        return `${event.chain.name}_${event.date + event.end_datetime}`;
      }
    });
    // const groupedEvents = _.groupBy(events, function (event) {
    //   return `${event.chain.name}_${event.date + event.end_datetime}`;
    // });


    // remove last item from groupedEvents array
    for (let key in groupedEvents) {
      if (groupedEvents[key].length > 1) {
        groupedEvents[key].pop();
      }
    }

    // loop over groupedEvents object and get the first array element
    const firstArrayItem = _.map(groupedEvents, function (value, key) { return value[0]; });

    // loop over groupedEvents object and get the last array element
    const lastArrayItem = _.map(groupedEvents, function (value, key) { return value[value.length - 1]; });

    // loop over firstArrayItem and add "multiDay" to the top level of each object
    const multiDayEvents = _.map(firstArrayItem, function (value, key) {
      if (firstArrayItem[key].datetime !== lastArrayItem[key].datetime) {
        // the "self" url on the even it the same, means there is only 1 event
        value.multiDay = true;
      }
      value.lastDay = lastArrayItem[key].date;
      value.allEvents = groupedEvents[firstArrayItem[key].chain.name];
      return value;
    });

    $scope.filtered_items = multiDayEvents;
    return $scope.filtered_items;
  };


  /***
   * @ngdoc method
   * @name pageChanged
   * @methodOf FD:fdAllEvents
   * @description
   * Change page of the event list
   */
  return $scope.pageChanged = function () {

    PaginationService.update($scope.pagination, $scope.filtered_items.length);
    return $rootScope.$broadcast('page:changed');
  };
});


// TODO load more events when end of initial collection is reached/next collection is requested/data is loaded when no event data is present
// $scope.$on 'month_picker:month_changed', (event, month, last_month_shown) ->
//   return if !$scope.items or $scope.mode is 0
//   last_event = _.last($scope.items).date
//   # if the last event is in the same month as the last one shown, get more events
//   if last_month_shown.start_date.isSame(last_event, 'month')
//     $scope.start_date = last_month_shown.start_date
//     $scope.loadEventData()



// WEBPACK FOOTER //
// ../src/public/javascripts/all-events/all_events.controller.js